
import React, { useState } from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import ImageUploader from '../../ImageUploader';

interface BasicInfoSectionProps {
  formValues: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  handleImageUpload: (url: string) => void;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ 
  formValues, 
  handleInputChange,
  handleImageUpload 
}) => {
  const { t } = useTranslationUtils();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">{t('admin.badgeBasicInfo', 'Basic Information')}</h3>
      
      <div className="grid gap-4 md:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="name">{t('admin.badgeName', 'Badge Name')}<span className="text-destructive">*</span></Label>
          <Input
            id="name"
            name="name"
            placeholder={t('admin.enterBadgeName', 'Enter badge name')}
            value={formValues.name}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="description">{t('admin.description', 'Description')}</Label>
          <Textarea
            id="description"
            name="description"
            placeholder={t('admin.enterDescription', 'Enter badge description')}
            value={formValues.description}
            onChange={handleInputChange}
            rows={1}
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label>{t('admin.badgeImage', 'Badge Image')}</Label>
        <ImageUploader
          existingUrl={formValues.image_url}
          onUpload={handleImageUpload}
          accept="image/*"
          bucketName="badges"
        />
      </div>
    </div>
  );
};

export default BasicInfoSection;
